import React from "react";
import FundManagement from "../../features/icfundmanagement";

const FundManagementPage = () => <FundManagement />

export default FundManagementPage;